import React from 'react';
import {
    LogLevel as SignalRLogLevel,
    HubConnectionBuilder,
} from '@microsoft/signalr';

const HubConnectionContext = React.createContext(null);

export const useHubConnection = () => React.useContext(HubConnectionContext);

export const WithHubConnectionContext = (props) => {
    const { opts, children } = props;

    const connection = new HubConnectionBuilder()
        .withUrl(opts.url)
        .configureLogging(opts.logLevel ?? SignalRLogLevel.Information)
        .withAutomaticReconnect()
        .build();

    const connectionFuture = connection.start().then(() => connection);

    return (
        <HubConnectionContext.Provider value={connectionFuture}>
            {children}
        </HubConnectionContext.Provider>
    );
};
